import axios from "axios";

export const API = process.env.REACT_APP_API_URL || "http://localhost:8008";

// Single shared axios instance. The auth context attaches the bearer token via
// `setAuthToken` whenever the user logs in / out.
export const apiClient = axios.create({
  baseURL: API,
});

export function setAuthToken(token) {
  if (token) {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common["Authorization"];
  }
}

// The auth context registers a handler here so an expired/invalid session (401)
// on any authenticated request is handled gracefully (log out + "please sign in
// again") instead of surfacing a raw "Token expired" error.
let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthAttempt = /\/api\/auth\/(login|register|forgot|reset)/.test(url);
    const hasToken = Boolean(apiClient.defaults.headers.common["Authorization"]);
    // Only treat a 401 as an expired session when it's an authenticated request
    // (not a failed login) — a failed login should show its own error.
    if (status === 401 && !isAuthAttempt && hasToken && typeof onUnauthorized === "function") {
      onUnauthorized();
    }
    return Promise.reject(error);
  },
);

// Boot-time hydration: if a token is already in localStorage, attach it.
const stored = typeof window !== "undefined" ? window.localStorage.getItem("vizaura_token") : null;
if (stored) setAuthToken(stored);
